<template lang="pug">
  b-container.white-space(fluid="fluid")
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-form-text.ml-3 ※ご契約ユーザー数の変更に伴い、サービスの一時停止が発生する場合があります。
      b-form-text.ml-3 ※年額（12ヶ月支払い）で契約されているお客様は、契約期間途中で契約ユーザーを減らす場合、既にお支払いいただいている費用を返金することはできませんので予めご了承のほどお願いいたします。
      b-form-text.ml-3 ※変更お申し込みいただいている場合、表示されている内容と実際の環境が一致しないことがあります。
      b-form-text.ml-3
        | ※各商品の定価は
        a(href="https://www.desknets.com/neo/price/", target="_blank") こちら
        | をご確認ください。
      b-form-text.ml-3
        .text-danger ※ご注文いただく製品の数量変更は、全て増加か全て減少のどちらか一方となるようご入力ください。
      b-form-text.ml-3
        .text-danger ※年額（12か月支払い）で契約されているお客様のユーザー追加分は開通日即日で残月数分のご請求が発生します。
      b-form-text.ml-3.mb-3
        .text-danger ※1日開通の場合は当月課金です。
      app-messages(:errorMessages="error_msg_list")
      h5#service.font-weight-bold.mt-3.ml-3.border-top.border-bottom.py-2.plan-title-bg-color.mb-0.mr-3 ご契約中のプラン
      b-row.border-bottom.plan-border-color.row-height-size.py-2.mx-3
        b-col.pr-0.title-col-size.border-right(cols="5")
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size 現在の契約数
        b-col.input-col-size.border-right(cols="2")
          b-form-text.text-center.column-item-font-size 変更後の契約数
        b-col
          b-form-text.text-center.column-item-font-size 増減数

      //- desknet's NEO
      b-row.height-size.border-primary.pb-3.mt-3.mx-3(v-if="neo.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold ライト
            b-button.mb-1.ml-2(pill, variant="outline-primary", size="sm", @click="changePlan") プラン変更
          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
          b-form-text.mt-3 {{neo.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{neo.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="neo.value", style="text-align: right;", :placeholder="neo.placeholder", maxlength="5", :state="neo.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of neo.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceNeo.length > 0 && getDifferenceNeo !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="neo.now_value - neo.value > 0 ? 'primary' : 'success'") {{getDifferenceNeo}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceNeo}}

      //- ライト
      b-row.height-size.plan-border-color.pb-3.mt-3.mx-3(v-if="light.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold ライト
            b-button.mb-1.ml-2(pill, variant="outline-primary", size="sm", @click="changePlan") プラン変更
          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
          b-form-text.mt-3 {{light.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{light.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="light.value", style="text-align: right;", :placeholder="light.placeholder", maxlength="5", :state="light.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of light.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceLight.length > 0 && getDifferenceLight !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="light.now_value - light.value > 0 ? 'primary' : 'success'") {{getDifferenceLight}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceLight}}

      //- スタンダード
      b-row.height-size.plan-border-color.pb-3.mt-3.mx-3(v-if="standard.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold スタンダード
            b-button.mb-1.ml-2(pill, variant="outline-primary", size="sm", @click="changePlan") プラン変更
          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
          img.mr-3.logo_appsuite(src="@/assets/images/logo_appsuite.png")
          b-form-text.mt-3 {{standard.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{standard.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="standard.value", style="text-align: right;", :placeholder="standard.placeholder", maxlength="5", :state="standard.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of standard.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceStandard.length > 0 && getDifferenceStandard !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="standard.now_value - standard.value > 0 ? 'primary' : 'success'") {{getDifferenceStandard}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceStandard}}

      //- プレミアム
      b-row.height-size.plan-border-color.pb-3.mt-3.mx-3(v-if="premium.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold プレミアム
            b-button.mb-1.ml-2(pill, variant="outline-primary", size="sm", @click="changePlan") プラン変更
          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
          img.mr-3.logo_appsuite(src="@/assets/images/logo_appsuite.png")
          img.mr-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
          b-form-text.mt-3 {{premium.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{premium.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="premium.value", style="text-align: right;", :placeholder="premium.placeholder", maxlength="5", :state="premium.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of premium.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferencePremium.length > 0 && getDifferencePremium !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="premium.now_value - premium.value > 0 ? 'primary' : 'success'") {{getDifferencePremium}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferencePremium}}

      //- チャットプラス
      b-row.height-size.plan-border-color.pb-3.mt-3.mx-3(v-if="chatplus.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold チャットプラス
            b-button.mb-1.ml-2(pill, variant="outline-primary", size="sm", @click="changePlan") プラン変更
          img.mr-3.logo_desknets(src="@/assets/images/logo_desknetsneo.png")
          img.mr-3.logo_chatluck(src="@/assets/images/logo_chatluck.png")
          b-form-text.mt-3 {{chatplus.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{chatplus.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="chatplus.value", style="text-align: right;", :placeholder="chatplus.placeholder", maxlength="5", :state="chatplus.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of chatplus.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceChatplus.length > 0 && getDifferenceChatplus !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="chatplus.now_value - chatplus.value > 0 ? 'primary' : 'success'") {{getDifferenceChatplus}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceChatplus}}

      h5.font-weight-bold.ml-3.border-top.border-bottom.py-2.neo-title-bg-color.mb-0.mr-3(v-if="isOptionExistFlg === true") desknet's NEO オプション

      //- appsuite（価格改定前）
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="app_suite_old.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{app_suite_old.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/appsuite/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{app_suite_old.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{app_suite_old.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="app_suite_old.value", style="text-align: right;", :placeholder="app_suite_old.placeholder", maxlength="5", :state="app_suite_old.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of app_suite_old.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceAppSuiteOld.length > 0 && getDifferenceAppSuiteOld !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="app_suite_old.now_value - app_suite_old.value > 0 ? 'primary' : 'success'") {{getDifferenceAppSuiteOld}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceAppSuiteOld}}

      // appsuite（価格改定後）
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="app_suite.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{app_suite.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/appsuite/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{app_suite.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{app_suite.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="app_suite.value", style="text-align: right;", :placeholder="app_suite.placeholder", maxlength="5", :state="app_suite.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of app_suite.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceAppSuite.length > 0 && getDifferenceAppSuite !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="app_suite.now_value - app_suite.value > 0 ? 'primary' : 'success'") {{getDifferenceAppSuite}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceAppSuite}}

      // desknet's ウェブ会議
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="web_conferencing.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{web_conferencing.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/webmtg/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{web_conferencing.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{web_conferencing.now_value}} 会議室
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="web_conferencing.value", style="text-align: right;", :placeholder="web_conferencing.placeholder", maxlength="5", :state="web_conferencing.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 会議室
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of web_conferencing.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceWebConferencing.length > 0 && getDifferenceWebConferencing !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="web_conferencing.now_value - web_conferencing.value > 0 ? 'primary' : 'success'") {{getDifferenceWebConferencing}} 会議室
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceWebConferencing}}

      // 交通費・経費精算
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="expense_settlement.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{expense_settlement.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/releases/v30/feature1.html", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{expense_settlement.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{expense_settlement.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-text.input-form-size.ml-2.number-form-font-size.text-right {{getItemValue}}
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of expense_settlement.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceExpenseSettlement.length > 0 && getDifferenceExpenseSettlement !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="expense_settlement.now_value - getItemValue > 0 ? 'primary' : 'success'") {{getDifferenceExpenseSettlement}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceExpenseSettlement}}

      // タイムカード＋CLOUZA
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="clouza.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{clouza.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/timecardp/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{clouza.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{clouza.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="clouza.value", style="text-align: right;", :placeholder="clouza.placeholder", maxlength="5", :state="clouza.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of clouza.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceClouza.length > 0 && getDifferenceClouza !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="clouza.now_value - clouza.value > 0 ? 'primary' : 'success'") {{getDifferenceClouza}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceClouza}}

      // Sync for smartphones
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="sync.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{sync.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/sync/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{sync.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{sync.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="sync.value", style="text-align: right;", :placeholder="sync.placeholder", maxlength="5", :state="sync.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of sync.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceSync.length > 0 && getDifferenceSync !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="sync.now_value - sync.value > 0 ? 'primary' : 'success'") {{getDifferenceSync}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceSync}}

      // セキュアブラウザ（端末認証なし）
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="secure.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{secure.name}}
          b-form-text.mt-0 {{secure.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{secure.now_value}} ユーザー
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-text.input-form-size.ml-2.number-form-font-size.text-right {{getItemValue}}
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 ユーザー
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of secure.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceSecure.length > 0 && getDifferenceSecure !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="secure.now_value - getItemValue > 0 ? 'primary' : 'success'") {{getDifferenceSecure}} ユーザー
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceSecure}}

      // クライアント認証
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="client.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{client.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/clientcert/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{client.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{client.now_value}} デバイス
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="client.value", style="text-align: right;", :placeholder="client.placeholder", maxlength="5", :state="client.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 デバイス
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of client.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceClient.length > 0 && getDifferenceClient !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="client.now_value - client.value > 0 ? 'primary' : 'success'") {{getDifferenceClient}} デバイス
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceClient}}

      // WebARENA
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="arena.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{arena.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/features/service_cloud/mail/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{arena.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{arena.now_value}} アカウント
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="arena.value", style="text-align: right;", :placeholder="arena.placeholder", maxlength="5", :state="arena.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 アカウント
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of arena.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceArena.length > 0 && getDifferenceArena !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="arena.now_value - arena.value > 0 ? 'primary' : 'success'") {{getDifferenceArena}} アカウント
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceArena}}

      // CYBERMAILΣ
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="cyber.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{cyber.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{cyber.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{cyber.now_value}} アカウント
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="cyber.value", style="text-align: right;", :placeholder="cyber.placeholder", maxlength="5", :state="cyber.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 アカウント
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of cyber.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceCyber.length > 0 && getDifferenceCyber !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="cyber.now_value - cyber.value > 0 ? 'primary' : 'success'") {{getDifferenceCyber}} アカウント
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceCyber}}

      // MAILGATES Σ
      b-row.height-size.border-bottom.border-primary.pb-3.mt-3.mx-3(v-if="mailgates.now_value")
        b-col.pr-0.title-col-size.border-right(cols="5")
          b-form-text.product-name-font-size.font-weight-bold {{mailgates.name}}
            b-button.detail-button.ml-2(size="sm", variant="primary", href="https://www.desknets.com/neo/users/cybermail/#mailgates", target="_blank") 詳細はこちら ＞
          b-form-text.mt-0 {{mailgates.description}}
        b-col.p-0.border-right(cols="2")
          b-form-text.text-center.column-item-font-size {{mailgates.now_value}} アカウント
        b-col.input-col-size.border-right(cols="2")
          b-row.p-0.mx-auto
            b-col.p-0.ml-3
              b-form-input.input-form-size.ml-2.number-form-font-size(size="sm", type="text", v-model="mailgates.value", style="text-align: right;", :placeholder="mailgates.placeholder", maxlength="5", :state="mailgates.error_msg.length === 0 ? null : false")
            b-col.p-0.text-left
              b-form-text.column-item-font-size.ml-1 アカウント
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of mailgates.error_msg") {{error_msg}}
        b-col.p-0.text-center.ml-3.change-value-col-size(v-if="getDifferenceMailgates.length > 0 && getDifferenceMailgates !== '変更なし'")
          b-form-text.column-item-font-size(:text-variant="mailgates.now_value - mailgates.value > 0 ? 'primary' : 'success'") {{getDifferenceMailgates}} アカウント
        b-col.p-0.text-center.ml-3.change-value-col-size(v-else)
          b-form-text.column-item-font-size(text-variant="secondary") {{getDifferenceMailgates}}

      // 製品増減数のエラー表示
      b-row.mt-3.mx-3
        b-col
          b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of increase_decrease.error_msg") {{error_msg}}
      b-form-text(style="height: 15px;")

      b-row
        b-col
          h5#preferred_date.font-weight-bold.ml-3.border-top.border-bottom.py-2.common-title-bg-color.mb-0.mr-3 変更希望日
          b-form-group.align-content.mt-3(label-cols="3", label-align="right", label-size="sm", label="変更希望日", label-class="required-label-after")
            b-form-datepicker.mb-2.datepicker-size(
              size="sm",
              v-model="preferred_date.value",
              :min="preferred_date.min",
              :max="preferred_date.max"
              :placeholder="preferred_date.placeholder",
              :hide-header="true",
              :date-format-options="preferred_date.format_option",
              :date-disabled-fn="dateDisabled",
              :state="preferred_date.error_msg.length !== 0 ? false : null"
            )
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of preferred_date.error_msg") {{error_msg}}
            b-form-text.description-text-position {{preferred_date.description}}

      b-row
        b-col
          h5#estimate.font-weight-bold.ml-3.border-top.border-bottom.py-2.common-title-bg-color.mb-0.mr-3.mt-3 お見積番号
          b-form-group.align-content.mt-3(label-cols="3", label-align="right", label-size="sm", label="お見積番号", label-class="elective-label-after")
            .form-inline
              b-form-text.mr-1 No.
              b-form-textarea.mb-2.estimate-size(v-model="estimate.value", rows="3", :state="estimate.error_msg.length === 0 ? null : false")
            b-form-text.align-left.text-left.error-message-color.error-message-space(v-for="(error_msg) of estimate.error_msg") {{error_msg}}
            b-form-text.description-text-position(text-variant="danger") {{estimate.description_1}}
            b-form-text.description-text-position {{estimate.description_2}}
      b-form-text(style="height: 15px;")

      b-row
        b-col
          h5#remarks.font-weight-bold.ml-3.border-top.border-bottom.py-2.common-title-bg-color.mb-0.mr-3 備考
          b-form-group.white-space.align-content.ml-3.mr-3.mt-3(label-cols="12", label-align="left", label-size="sm", label="弊社への連絡事項などございましたら、こちらにご記入ください。", label-class="elective-label-after")
            b-form-textarea(v-model="remarks.value", rows="4", :state="remarks.error_msg.length === 0 ? null : false")
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of remarks.error_msg") {{error_msg}}
          b-form-text(style="height: 30px;")
      b-row
        b-col
          contract-conditions.mx-3.mb-4(
            :show-neo="now_contract !== ''",
            :show-chat="premium.now_value !== '' || chatplus.now_value !== ''",
            :show-clouza="clouza.now_value !== ''",
            :show-arena="arena.now_value !== ''",
            :show-cyber="cyber.now_value !== ''",
            :show-mailgates="mailgates.now_value !== ''")
      b-row(v-if="has_special_priced_item === false")
        b-col
          //- 見積書
          h5#quote_kind.font-weight-bold.ml-3.border-top.border-bottom.py-2.common-title-bg-color.mb-0.mr-3 見積書を作成する
          b-form-text
            app-messages(:errorMessages="quote_kind.error_msg")
            b-container.my-2.pl-2
              b-row
                b-col(cols="1")
                b-col(cols="7")
                  b-form-checkbox(v-model="quote_kind.total" size="lg")
                    span 総額見積書
                    span.checkbox-description （変更反映後の総額費用）
                  b-form-checkbox(v-model="quote_kind.individual", :disabled="isDisabledIndividualQuotation" size="lg")
                    span 個別見積書
                    span.checkbox-description （変更分のみの差分費用）
                  p.ml-4.mb-0 ※個別見積書はユーザー数の減算や解約申請、オプションの変更がない場合のみ作成できます。
                  p.ml-4.mb-0 ※個別見積書は見積合計金額が0円の場合、作成することはできません。
                b-col(cols="3")
                  b-button.float-right.mr-5.mt-5(pill, variant="outline-success", size="lg", @click="createQuotation", :disabled="isSending")
                    .float-left.search_message.mr-1.font-weight-bold 見積書作成
                    b-icon.float-right.next-icon(icon="arrow-right-circle")
          b-form-text(style="height: 30px;")

      b-row
        b-col
          //- 申し込む
          h5.font-weight-bold.ml-3.border-top.border-bottom.py-2.common-title-bg-color.mb-0.mr-3 変更を申し込む
          b-form-text
            b-container.my-2
              b-row
                b-col(cols="7")
                b-col(cols="4")
                  b-button.order-confirm-button.float-right.mr-5.my-3(v-b-modal.order_confirm, pill, variant="outline-success", size="lg", :disabled="isSending")
                    span.search_message.mr-1.font-weight-bold 申し込みを確定する
                    b-icon.next-icon(icon="arrow-right-circle")
                    b-modal#order_confirm(centered, size="ml", title="ご確認", @ok="sendOrder", ok-title="はい", cancel-title="いいえ")
                      span 以下の商品のユーザー数変更申し込みを行います。
                      b-form-text.text-font(v-if="getItemValue.length > 0") ・{{getItemName}}
                      b-form-text.text-font(v-if="app_suite_old.value.length > 0") ・{{app_suite_old.name}}
                      b-form-text.text-font(v-if="app_suite.value.length > 0") ・{{app_suite.name}}
                      b-form-text.text-font(v-if="web_conferencing.value.length > 0") ・{{web_conferencing.name}}
                      b-form-text.text-font(v-if="getItemValue.length > 0 && this.expense_settlement.now_value > 0") ・{{this.expense_settlement.name}}
                      b-form-text.text-font(v-if="clouza.value.length > 0") ・{{clouza.name}}
                      b-form-text.text-font(v-if="sync.value.length > 0") ・{{sync.name}}
                      b-form-text.text-font(v-if="getItemValue.length > 0 && this.secure.now_value > 0") ・{{secure.name}}
                      b-form-text.text-font(v-if="client.value.length > 0") ・{{client.name}}
                      b-form-text.text-font(v-if="arena.value.length > 0") ・{{arena.name}}
                      b-form-text.text-font(v-if="cyber.value.length > 0") ・{{cyber.name}}
                      b-form-text.text-font(v-if="mailgates.value.length > 0") ・{{mailgates.name}}
                      b-form-text.mt-3(v-show="billing_period === '1'")
                        .text-danger ※年額（12ヶ月支払い）で契約されているお客様は、契約期間途中で
                        .text-danger &nbsp;&nbsp;&nbsp;&nbsp;契約ユーザーを減らす場合、既にお支払いいただいている費用を
                        .text-danger &nbsp;&nbsp;&nbsp;&nbsp;返金することはできませんので予めご了承のほどお願いいたします。
</template>

<script>
import Api from "@/repositories/api";
import AppMessages from '@/components/AppMessages';
import SelectDatetime from "@/components/firstOrder/SelectDatetime";
import SelectDatetimeDouble from "@/components/firstOrder/SelectDatetimeDouble";
import Loading from '@/components/Loading'
import ContractConditions from "@/components/ContractConditions";

const C206ContractInfo = Api.get('c206ContractInfo');
const S213ContractDetailsRepository = Api.get("s213ContractDetails");
const S206NumberChangeRepository = Api.get("s206NumberChange");
const S214QuotationRepository = Api.get('s214Quotation');

export default {
  name: "NeoNumberChangeForm",
  components: {
    AppMessages,
    ContractConditions,
    SelectDatetime,
    SelectDatetimeDouble,
    Loading,
  },
  props: {
    // 優待価格商品保有フラグ
    has_special_priced_item: { type: Boolean, required: false },
  },
  data() {
    const number_placeholder = "（半角数字）";

    return {
      title_class: "font-weight-bold ml-3 border-top border-bottom py-2 neo-title-bg-color",
      data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-primary label-font-size",
      option_data_class: "ml-3 pt-2 px-2 mb-0 border-top border-primary label-font-size",
      option_data_last_class: "ml-3 pt-2 px-2 mb-2 border-top border-bottom border-primary label-font-size",

      chat_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 chat-title-bg-color",
      chat_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-success label-font-size",

      other_title_class: "font-weight-bold ml-3 border-top border-bottom py-2 other-title-bg-color",
      other_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom label-font-size",

      // 契約番号
      contract_no: "",

      // 契約中の商品名
      now_contract: "",

      // desknet's NEO
      neo: {
        name: "ライト（desknet's NEO）",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // ライトプラン
      light: {
        name: "ライト（desknet's NEO）",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // スタンダードプラン
      standard: {
        name: "スタンダード（desknet's NEO + AppSuite）",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // プレミアムプラン
      premium: {
        name: "プレミアム（desknet's NEO + AppSuite + ChatLuck）",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // チャットプラスプラン
      chatplus: {
        name: "チャットプラス（desknet's NEO + ChatLuck）",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // app_suite（価格改定前）
      app_suite_old: {
        name: "業務アプリ作成ツール AppSuite",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーから、desknet's NEOの契約ユーザー数までのご契約となります。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // app_suite
      app_suite: {
        name: "業務アプリ作成ツール AppSuite",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーから、desknet's NEOの契約ユーザー数までのご契約となります。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // desknet's NEO ウェブ会議
      web_conferencing: {
        name: "desknet's NEO ウェブ会議",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約会議室は1会議室から、最大10会議室までのご契約となります。\n※ご契約単位は1会議室単位です。",
        error_msg: [],
      },
      // 交通費・経費精算
      expense_settlement: {
        name: "交通費・経費精算",
        now_value: "",
        description: "※desknet's NEOのご契約ユーザー数と同数でのご契約となります。",
        error_msg: [],
      },
      // タイムカード＋CLOUZA
      clouza: {
        name: "タイムカード＋CLOUZA",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は20ユーザーです。\n" +
            "※ご契約単位は10ユーザー単位です。",
        error_msg: [],
      },
      // Sync for smartphones
      sync: {
        name: "Sync for smartphones",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約ユーザー数は5ユーザーです。\n※ご契約単位は1ユーザー単位です。",
        error_msg: [],
      },
      // セキュアブラウザ
      secure: {
        name: "セキュアブラウザ（端末認証なし）",
        secure_browser_terminal: "",
        now_value: "",
        description: "※desknet's NEOのご契約ユーザー数と同数でのご契約となります。",
        error_msg: [],
      },
      // クライアント認証
      client: {
        name: "クライアント認証",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最低契約デバイス数は5デバイスです。\n" +
            "※ご契約単位は1デバイス単位です。\n",
        error_msg: [],
      },
      // WebARENA
      arena: {
        name: "WebARENA",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最小25～最大1000アカウント迄ご利用可能です。\n※ご契約単位は1アカウント単位です。",
        error_msg: [],
      },
      // CYBERMAILΣ
      cyber: {
        name: "CYBERMAILΣ",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最小50アカウントからご利用可能です。\n※ご契約単位は10アカウント単位です。",
        error_msg: [],
      },
      // MAILGATES Σ
      mailgates: {
        name: "MAILGATES Σ",
        now_value: "",
        value: "",
        placeholder: number_placeholder,
        description: "※最小50アカウントからご利用可能です。\n※ご契約単位は10アカウント単位です。",
        error_msg: [],
      },
      // 増減数
      increase_decrease: {
        error_msg: [],
      },
      // 見積番号
      estimate: {
        value: "",
        placeholder: "",
        form_class: "",
        description_1: "既に弊社から見積を取得されている場合、必ずご記入ください。",
        description_2: "※見積書が複数ある場合、改行区切りですべての見積もり番号をご記入ください。",
        error_msg: [],
      },
      // 変更希望日
      preferred_date: {
        value: "",
        min: "",
        max: "",
        placeholder: "（カレンダーから選択）",
        description: "※弊社でお申込書受領後、3～4営業日ほどお時間いただいております。\n" +
          "※希望日が弊社休業日の場合、翌営業日のご希望として承ります。\n" +
          "※希望日は目安として承りますので、ご希望に添えない場合がございます。ご了承ください。",
        format_option: {
          year: "numeric",
          month: "long",
          day: "numeric",
        },
        error_msg: []
      },
      // 備考
      remarks: {
        value: "",
        error_msg: [],
      },
      // 見積書種類
      quote_kind: {
        total: false,
        individual: false,
        error_msg: []
      },
      // 対象製品（見積書作成API用）
      target_product: {
        name: '',
        order_type: '1'
      },
      // CLOUZA
      clouza_info: {},
      // セキュアブラウザ（端末認証なし）
      secure_info: {},
      // クライアント認証
      client_info: {},
      // WebARENA
      arena_info: {},
      // CYBERMAILΣ
      cyber_info: {},
      // MAILGATES Σ
      mailgates_info: {},

      // APIに送信するデータ
      request_data: {
        // 契約番号
        contract_no: "",
        target_product: [],
        order_product: {
          neo_user: "",
          light_user: "",
          standard_user: "",
          premium_user: "",
          chatplus_user: "",
          app_suite_user_old: "",
          app_suite_user: "",
          web_conferencing: "",
          option: {
            expense_settlement: "",
            clouza: {
              user: "",
            },
            sync: {
              user: "",
            },
          },
          security: {
            secure: {
              value: "",
            },
            client: {
              device: "",
            },
          },
          mail: {
            arena: {
              account: "",
            },
            cyber: {
              account: ""
            }
          },
          mail_security: {
            mailgates: {
              account: ""
            }
          }
        },
        other: {}
      },

      // 見積書作成APIに送信するデータ
      quotation_request_data: {},

      // 請求単位
      billing_period: "",

      // 画面上部のエラーメッセージ
      error_msg_list: [],

      // 読み込み中フラグ
      isLoading: false,
      // 変更処理中フラグ
      isSending: false,

      // エラー時のスクロール先
      error_scroll_position: 99,

      // オプション存在フラグ
      isOptionExistFlg: false
    }
  },
  computed: {
    // 入力のある商品のユーザー数を取得する
    getItemValue() {
      // 契約中のプランによって分岐させる
      switch (this.now_contract) {
        case 'light':
          return this.light.value
        case 'standard':
          return this.standard.value
        case 'premium':
          return this.premium.value
        case 'chatplus':
          return this.chatplus.value
        default:
          return this.neo.value
      }
    },
    // 入力のある商品の商品名を取得する
    getItemName() {
      // 契約中のプランによって分岐させる
      switch (this.now_contract) {
        case 'light':
          return this.light.name
        case 'standard':
          return this.standard.name
        case 'premium':
          return this.premium.name
        case 'chatplus':
          return this.chatplus.name
        default:
          return this.neo.name
      }
    },
    // desknet's NEO
    getDifferenceNeo() {
      return this.getDifferenceNumber(this.neo.now_value, this.neo.value);
    },
    // ライト
    getDifferenceLight() {
      return this.getDifferenceNumber(this.light.now_value, this.light.value);
    },
    // スタンダード
    getDifferenceStandard() {
      return this.getDifferenceNumber(this.standard.now_value, this.standard.value);
    },
    // プレミアム
    getDifferencePremium() {
      return this.getDifferenceNumber(this.premium.now_value, this.premium.value);
    },
    // チャットプラス
    getDifferenceChatplus() {
      return this.getDifferenceNumber(this.chatplus.now_value, this.chatplus.value);
    },
    // app_suite（価格改定前）
    getDifferenceAppSuiteOld() {
      return this.getDifferenceNumber(this.app_suite_old.now_value, this.app_suite_old.value);
    },
    // app_suite
    getDifferenceAppSuite() {
      return this.getDifferenceNumber(this.app_suite.now_value, this.app_suite.value);
    },
    // desknet's NEO ウェブ会議
    getDifferenceWebConferencing() {
      return this.getDifferenceNumber(this.web_conferencing.now_value, this.web_conferencing.value);
    },
    // 交通費・経費精算
    getDifferenceExpenseSettlement() {
      // 契約中の商品のユーザー数を使用する
      return this.getDifferenceNumber(this.expense_settlement.now_value, this[this.now_contract].value);
    },
    // タイムカード＋CLOUZA
    getDifferenceClouza() {
      return this.getDifferenceNumber(this.clouza.now_value, this.clouza.value);
    },
    // Sync for smartphones
    getDifferenceSync() {
      return this.getDifferenceNumber(this.sync.now_value, this.sync.value);
    },
    // セキュアブラウザ（端末認証なし）
    getDifferenceSecure() {
      // 契約中の商品のユーザー数を使用する
      return this.getDifferenceNumber(this.secure.now_value, this[this.now_contract].value);
    },
    // クライアント認証
    getDifferenceClient() {
      return this.getDifferenceNumber(this.client.now_value, this.client.value);
    },
    // WebARENA
    getDifferenceArena() {
      return this.getDifferenceNumber(this.arena.now_value, this.arena.value);
    },
    // CYBERMAILΣ
    getDifferenceCyber() {
      return this.getDifferenceNumber(this.cyber.now_value, this.cyber.value);
    },
    // MAILGATES Σ
    getDifferenceMailgates() {
      return this.getDifferenceNumber(this.mailgates.now_value, this.mailgates.value);
    },
    // 変更後の契約数が一つでも入力されているか
    isChangeAny() {
      // 各入力項目の入力値を連結
      let allStr = this.light.value
        + this.standard.value
        + this.premium.value
        + this.chatplus.value
        + this.neo.value
        + this.app_suite_old.value
        + this.app_suite.value
        + this.web_conferencing.value
        + this.clouza.value
        + this.sync.value
        + this.client.value
        + this.arena.value
        + this.cyber.value
        + this.mailgates.value;

      // 入力があればtrue
      return allStr.length > 0;
    },
    /**
     * 個別見積書のdisabled判定
     *
     * @return bool 個別見積書のdisabled値
     */
    isDisabledIndividualQuotation() {
      return (
        // [ライトプラン] 減算の場合
        this.getDifferenceLight.startsWith('-') === true ||
        // [スタンダードプラン] 減算の場合
        this.getDifferenceStandard.startsWith('-') === true ||
        // [プレミアムプラン] 減算の場合
        this.getDifferencePremium.startsWith('-') === true ||
        // [チャットプラスプラン] 減算の場合
        this.getDifferenceChatplus.startsWith('-') === true ||
        // [desknet's NEO] 減算の場合
        this.getDifferenceNeo.startsWith('-') === true ||
        // [app_suite] 減算の場合
        this.getDifferenceAppSuite.startsWith('-') === true ||
        // [desknet's NEO ウェブ会議] 減算の場合
        this.getDifferenceWebConferencing.startsWith('-') === true ||
        // [タイムカード＋CLOUZA] 減算の場合
        this.getDifferenceClouza.startsWith('-') === true ||
        // [Sync for smartphones] 減算の場合
        this.getDifferenceSync.startsWith('-') === true ||
        // [クライアント認証] 減算の場合
        this.getDifferenceClient.startsWith('-') === true ||
        // [WebARENA] 減算の場合
        this.getDifferenceArena.startsWith('-') === true ||
        // [CYBERMAILΣ] 減算の場合
        this.getDifferenceCyber.startsWith('-') === true ||
        // [MAILGATES Σ] 減算の場合
        this.getDifferenceMailgates.startsWith('-') === true
      )
    },
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // 見積書作成API用リクエストデータを初期化する
    this.initializeQuotationRequestData()

    S206NumberChangeRepository.view()
      .catch((err) => {
      // httpステータスコードが403の場合（権限エラー）
      if (err.response.status === 403) {
        // アプリケーションエラー画面へ遷移する
        this.$router.push({
          name: 'SupportApplicationError',
          params: {
            // 画面に表示するエラーメッセージ
            error_msg: this.forbidden_message
          }
        })
      }
    })

    // 画面パラメータに契約番号が存在する場合
    if ('contract_no' in this.$route.params) {
      // S21301_契約内容取得処理を実行
      this.getServiceData({contract_no: this.$route.params.contract_no})
      // 契約番号を設定
      this.contract_no = this.$route.params.contract_no
    }
    // 画面パラメータに契約番号が存在しない場合
    else {
      // C20601_契約情報取得処理を実行
      C206ContractInfo.get({contract_class: '5'})
        .then((response) => {
          // 取得した契約情報数が1件の場合
          if (response.data.data.length === 1) {
            // S21301_契約内容取得処理を実行
            this.getServiceData({contract_no: response.data.data[0].contract_no})
            // 契約番号を設定
            this.contract_no = response.data.data[0].contract_no
          }
          else {
            // セッションストレージにデータを保存
            sessionStorage.setItem('contract_class', '5')
            sessionStorage.setItem('previous', 'NeoNumberChange')

            // S11500_ご契約環境選択画面に遷移
            this.$router.push({ name: 'ContractSelect' })
          }
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, '画面表示処理', "Support")
        })
    }

    //--------------------
    // datepickerの最小日付
    //--------------------
    // 今日の日付の取得
    let currentDate = new Date();

    // 開始日(Dateオブジェクト)
    let startDate = new Date(currentDate);

    // 作業用最小日付
    let formedStartDate = '';

    // 祝日データを取得
    const holiday = this.getHolidays()

    // 本日から空ける必要のある営業日数(N日目が開始日)
    let preparationCount = this.getPreparationDayCount()

    // datepickerの最小値を作成
    // 最後の日が休日の場合に開始日を進める必要があるので、比較にイコールを含む
    for (let i = 0; i <= preparationCount; i++) {
      // YYYY-MM-DD の形式にする
      formedStartDate = startDate.getFullYear()
          + "-" + ("00" + (startDate.getMonth() + 1)).slice(-2)
          + "-" + ("00" + startDate.getDate()).slice(-2)

      // 土曜日または日曜日または祝日の場合はスキップ
      if (startDate.getDay() === 6 || startDate.getDay() === 0 || holiday.includes(formedStartDate) === true) {
        i--
      }

      // 最終日ではない場合は翌日へ
      if (i < preparationCount) {
        startDate.setDate(startDate.getDate() + 1)
      }
    }

    // 最小日付設定
    this.preferred_date.min = formedStartDate

    //--------------------
    // datepickerの最大日付
    //--------------------
    // 翌月末の日付取得
    let maxDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
    this.preferred_date.max = maxDate.getFullYear()
        + "-" + ("00" + (maxDate.getMonth() + 1)).slice(-2)
        + "-" + ("00" + maxDate.getDate()).slice(-2)
  },
  methods: {
    /**
     * プラン変更ボタンを押した際の処理
     */
    changePlan() {
      // 「S10302_プラン選択」画面へ遷移する
      this.$router.push({
        name: 'ApplyPlan',
        params: {
          // 契約番号
          contract_no: this.contract_no
        }
      })
    },
    /**
     * ご契約内容を取得する
     *
     * @param {object} params リクエストパラメータ
     */
    getServiceData(params) {
      // S21301_契約内容取得処理を実行
      S213ContractDetailsRepository.view(params)
        // 成功時
        .then((response) => {
          const apiData = response.data.data[0]
          let plan_user = ''

          // セットプラン
          // ライト
          if (typeof apiData.light_user !== 'undefined') {
            // ユーザー数
            this.light.now_value = apiData.light_user
            plan_user = apiData.light_user
            this.now_contract = 'light'
          }
          // スタンダード
          if (typeof apiData.standard_user !== 'undefined') {
            // ユーザー数
            this.standard.now_value = apiData.standard_user
            plan_user = apiData.standard_user
            this.now_contract = 'standard'
          }
          // プレミアム
          if (typeof apiData.premium_user !== 'undefined') {
            // ユーザー数
            this.premium.now_value = apiData.premium_user
            plan_user = apiData.premium_user
            this.now_contract = 'premium'
          }
          // チャットプラス
          if (typeof apiData.chatplus_user !== 'undefined') {
            // ユーザー数
            this.chatplus.now_value = apiData.chatplus_user
            plan_user = apiData.chatplus_user
            this.now_contract = 'chatplus'
          }

          if (typeof apiData.neo !== 'undefined') {
            // desknet's NEO ユーザー数
            if (typeof apiData.neo.neo_user !== 'undefined') {
              // ユーザー数
              this.neo.now_value = apiData.neo.neo_user
              plan_user = apiData.neo.neo_user
              this.now_contract = 'neo'
            }

            // AppSuite ユーザー数
            if (typeof apiData.neo.app_suite_user !== 'undefined' || typeof apiData.neo.app_suite_user_old !== 'undefined') {
              // オプション存在フラグをON
              this.isOptionExistFlg = true
              // （価格改定後）
              if (typeof apiData.neo.app_suite_user !== 'undefined') {
                // ユーザー数
                this.app_suite.now_value = apiData.neo.app_suite_user
              }
              // （価格改定前）
              if (typeof apiData.neo.app_suite_user_old !== 'undefined') {
                // ユーザー数
                this.app_suite_old.now_value = apiData.neo.app_suite_user_old
              }
            }

            // desknet's NEO ウェブ会議 会議室の数
            if (typeof apiData.neo.web_conferencing !== 'undefined') {
              // オプション存在フラグをON
              this.isOptionExistFlg = true
              // 会議室の数
              this.web_conferencing.now_value = apiData.neo.web_conferencing
            }

            // オプションサービス
            if (typeof apiData.neo.option !== 'undefined') {
              let option = apiData.neo.option

              // 交通費・経費精算
              if (typeof option.expense_settlement !== 'undefined' && option.expense_settlement === true) {
                // オプション存在フラグをON
                this.isOptionExistFlg = true

                this.expense_settlement.now_value = plan_user
              }

              // タイムカード＋CLOUZA
              if (typeof option.clouza !== 'undefined') {
                // オプション存在フラグをON
                this.isOptionExistFlg = true

                this.clouza.now_value = option.clouza.user
                this.clouza_info = option.clouza
              }

              // Sync for smartphones
              if (typeof option.sync !== 'undefined') {
                // オプション存在フラグをON
                this.isOptionExistFlg = true

                this.sync.now_value = apiData.neo.option.sync.user
              }
            }

            // セキュリティオプション
            if (typeof apiData.neo.security !== 'undefined') {
              let security = apiData.neo.security

              // セキュアブラウザ（端末認証なし）
              if (security.secure !== undefined && security.secure.secure_browser_terminal !== undefined && security.secure.secure_browser_terminal === '01') {
                // オプション存在フラグをON
                this.isOptionExistFlg = true
                this.secure.now_value = plan_user
                this.secure_info = security.secure
              }

              // クライアント認証
              if (security.client !== undefined) {
                // オプション存在フラグをON
                this.isOptionExistFlg = true
                // デバイス数
                this.client.now_value = security.client.device
                this.client_info = security.client
              }
            }

            // メールサービス
            if (typeof apiData.neo.mail !== 'undefined') {
              let mail = apiData.neo.mail
              // WebARENA
              if (typeof mail.arena !== 'undefined') {
                // オプション存在フラグをON
                this.isOptionExistFlg = true
                // アカウント数
                this.arena.now_value = mail.arena.account
                this.arena_info = mail.arena
              }

              // CYBERMAILΣ
              if (typeof mail.cyber !== 'undefined') {
                // オプション存在フラグをON
                this.isOptionExistFlg = true
                // アカウント数
                this.cyber.now_value = mail.cyber.account
                this.cyber_info = mail.cyber
              }
            }

            // メールセキュリティサービス
            if (apiData.neo.mail_security !== undefined) {
              let mail_security = apiData.neo.mail_security

              // MAILGATES Σ
              if (mail_security.mailgates !== undefined) {
                // オプション存在フラグをON
                this.isOptionExistFlg = true

                // アカウント数
                this.mailgates.now_value = mail_security.mailgates.account
                this.mailgates_info = mail_security.mailgates
              }
            }
          }

          // 請求単位保存
          this.billing_period = apiData.neo.billing_period
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, '画面表示処理', "Support")
        })
        .finally(() => {
          // 読み込み完了
          this.isLoading = false
        })
    },
    /**
     * datepickerの選択不可日付を設定する
     *
     * @param  {string}    ymd  「YYYYMMDD」形式の対象日付
     * @param  {object}    date 対象日付のDateオブジェクト
     * @return {boolean|*} 選択できるか
     */
    dateDisabled(ymd, date) {
      // 曜日を取得する（日曜日 - 土曜日：0 - 6）
      const iWeekday = date.getDay()

      // 各日付の「YYYY-mm-dd」形式
      const day = date.getFullYear()
          + "-" + ("00" + (date.getMonth() + 1)).slice(-2)
          + "-" + ("00" + date.getDate()).slice(-2)

      // 祝日データを取得
      const holiday = this.getHolidays()

      // 日曜日と土曜日と祝日の場合、選択不可にする
      return iWeekday === 0 || iWeekday === 6 || holiday.includes(day)
    },
    /**
     * 現在の契約数と変更後の契約数の差分を取得する
     *
     * @param  now_value    現在の契約数
     * @param  change_value 変更後の契約数
     * @return string       増減数に表示する文字列
     */
    getDifferenceNumber(now_value, change_value) {
      // 空白スペース削除
      const removeSpace = change_value.replace(/\D/g, '');

      // 変更後の契約数が数値以外
      if (isNaN(change_value) || !change_value || removeSpace.length <= 0 || removeSpace !== change_value) {
        // 何も表示しない
        return '';
      }

      // 変更後の契約数と現在の契約数の差分算出
      let differenceNumber = removeSpace - now_value

      // 差分がプラス
      if (differenceNumber > 0) {
        // 頭に「+」をつける
        return '+ ' + Math.abs(differenceNumber)
      }
      // 差分がマイナス
      else if (differenceNumber < 0) {
        // 頭に「-」をつける
        return '- ' + Math.abs(differenceNumber)
      }
      // 差分がないとき
      else {
        // 「変更なし」を表示
        return '変更なし';
      }
    },
    /**
     * 登録処理
     */
    sendOrder() {
      // ボタンをdisabledにする
      this.isSending = true

      // エラー時のスクロール先をリセット
      this.error_scroll_position = 99;

      // リクエストデータを作成する
      this.createRequestData()

      // 表示されているエラーの消去
      this.resetErrorMsg()

      // API呼び出し
      S206NumberChangeRepository.add(this.request_data)
      // 成功時
      .then(() => {
        // お申し込み履歴画面へ遷移する
        // 画面パラメータに契約番号を設定
        this.$router.push({
          name: "OrderHistory",
          params: {
            contract_no: this.request_data.contract_no
          }
        })
      })
      // 失敗時
      .catch((err) => {
        // 共通のエラー処理
        this.apiError(err, '登録処理', "Support")
        // レスポンスデータがある場合
        if (err.response !== null && err.response !== undefined) {
          // httpステータスコードが403の場合（権限エラー）
          if (err.response.status === 403) {
            // 画面上部にエラーメッセージを表示する
            this.error_msg_list.push(this.forbidden_message);

            // 画面一番上へスクロールをする
            this.pageTopScroll();
          }
          // エラーメッセージがある場合
          if (err.response.data.error_list !== null && err.response.data.error_list !== undefined) {
            // エラー要素の取得
            const errList = err.response.data.error_list
            // 各要素のエラーメッセージを出力する
            errList.forEach((objErr) => {
              let target = objErr.target
              let errorMsg = objErr.error_msg
              this.responseErrorMessage(target, errorMsg)
            })

            // エラーが出てる場所までスクロール
            this.scrollErrorPosition(this.error_scroll_position)
          }
        }
      })
      .finally(() => {
        // ボタンのdisabledを解除する
        this.isSending = false
      })
    },
    /**
     * リクエストデータを作成する
     */
    createRequestData() {
      // 初期化
      this.request_data = {
        // 契約番号
        contract_no: "",
        // 数量を変更する商品
        target_product: [],
        order_product: {
          neo_user:           "", // desknet's NEO
          light_user:         "", // ライト
          standard_user:      "", // スタンダード
          premium_user:       "", // プレミアム
          chatplus_user:      "", // チャットプラス
          app_suite_user_old: "", // appsuite（価格改定前）
          app_suite_user:     "", // appsuite
          web_conferencing:   "", // Web会議
          option: {
            // 交通費・経費
            expense_settlement: "",
            clouza: {
              // clouza
              user: "",
            },
            sync: {
              // Sync for smartphones
              user: "",
            },
          },
          security: {
            secure: {
              // セキュアブラウザ（端末認証なし）
              value: "",
            },
            client: {
              // クライアント認証
              device: "",
            },
          },
          mail: {
            arena: {
              // WebARENE
              account: "",
            },
            cyber: {
              // CYBERMAILΣ
              account: ""
            }
          },
          mail_security: {
            mailgates: {
              // MAILGATES Σ
              account: ""
            }
          }
        },
        // その他
        other: {}
      }

      // 契約番号
      this.request_data.contract_no = this.contract_no
      // desknet's NEO ユーザー数
      if (this.neo.value.length > 0) {
        this.request_data.target_product.push('neo_user')
        this.request_data.order_product.neo_user = this.neo.value;
      }
      // ライト ユーザー数
      if (this.light.value.length > 0) {
        this.request_data.target_product.push('light_user')
        this.request_data.order_product.light_user = this.light.value;
      }
      // スタンダード ユーザー数
      if (this.standard.value.length > 0) {
        this.request_data.target_product.push('standard_user')
        this.request_data.order_product.standard_user = this.standard.value;
      }
      // プレミアム ユーザー数
      if (this.premium.value.length > 0) {
        this.request_data.target_product.push('premium_user')
        this.request_data.order_product.premium_user = this.premium.value;
      }
      // チャットプラス ユーザー数
      if (this.chatplus.value.length > 0) {
        this.request_data.target_product.push('chatplus_user')
        this.request_data.order_product.chatplus_user = this.chatplus.value;
      }
      // AppSuite（価格改定前） ユーザー数
      if (this.app_suite_old.value.length > 0) {
        this.request_data.target_product.push('app_suite_user_old')
        this.request_data.order_product.app_suite_user_old = this.app_suite_old.value;
      }
      // AppSuite ユーザー数
      if (this.app_suite.value.length > 0) {
        this.request_data.target_product.push('app_suite_user')
        this.request_data.order_product.app_suite_user = this.app_suite.value;
      }
      // Web会議室 会議室数
      if (this.web_conferencing.value.length > 0) {
        this.request_data.target_product.push('web_conferencing')
        this.request_data.order_product.web_conferencing = this.web_conferencing.value;
      }
      // 交通費・経費清算
      if (this[this.now_contract].value.length > 0 && this.expense_settlement.now_value.length > 0) {
        this.request_data.target_product.push('expense_settlement')
        this.request_data.order_product.option.expense_settlement = true;
      }
      // clouza ユーザー数
      if (this.clouza.value.length > 0) {
        this.request_data.target_product.push('option.clouza')
        this.request_data.order_product.option.clouza.user = this.clouza.value;
      }
      // Sync for smartphones ユーザー数
      if (this.sync.value.length > 0) {
        this.request_data.target_product.push('option.sync')
        this.request_data.order_product.option.sync.user = this.sync.value;
      }
      // セキュアブラウザ（端末認証なし） ユーザー数
      if (this[this.now_contract].value.length > 0 && this.secure.now_value.length > 0) {
        this.request_data.target_product.push('security.secure')
        this.request_data.order_product.security.secure.secure_browser_device = this[this.now_contract].value;
      }
      // クライアント認証 デバイス数
      if (this.client.value.length > 0) {
        this.request_data.target_product.push('security.client')
        this.request_data.order_product.security.client.device = this.client.value;
      }
      // WEBARENA アカウント数
      if (this.arena.value.length > 0) {
        this.request_data.target_product.push('mail.arena')
        this.request_data.order_product.mail.arena.account = this.arena.value;
      }
      // CYBERMAILΣ アカウント数
      if (this.cyber.value.length > 0) {
        this.request_data.target_product.push('mail.cyber')
        this.request_data.order_product.mail.cyber.account = this.cyber.value;
      }
      // MAILGATES Σ アカウント数
      if (this.mailgates.value.length > 0) {
        this.request_data.target_product.push('mail_security.mailgates')
        this.request_data.order_product.mail_security.mailgates.account = this.mailgates.value;
      }

      // 共通部品
      // 開通希望日
      if (this.preferred_date.value !== null && this.preferred_date.value !== '') {
        this.request_data.other.opening_date = this.preferred_date.value
      }
      // 見積番号
      if (this.estimate.value !== null && this.estimate.value !== '') {
        this.request_data.other.estimate_no = this.estimate.value
      }
      // 備考
      if (this.remarks.value !== null && this.remarks.value !== '') {
        this.request_data.other.order_remarks = this.remarks.value
      }
    },
    /**
     * 見積書の作成をおこなう
     */
    createQuotation() {
      // ボタンをdisabledにする
      this.isSending = true

      // 見積書作成API用リクエストデータを作成する
      this.createQuotationRequestData()

      // 表示されているエラーの消去
      this.resetErrorMsg()

      // 見積書作成処理を実行
      S214QuotationRepository.create(this.quotation_request_data)
        // 処理が成功した場合
        .then(() => {
          // S11700_見積書一覧画面に遷移
          this.$router.push({ name: 'QuotationList' })
        })
        // 処理が失敗した場合
        .catch((error) => {
          // エラーレスポンスがある場合
          if (error.response && 'status' in error.response) {
            // 共通のエラー処理
            this.apiError(error, '見積書作成処理', 'Support')

            // バリデーションエラー
            if (error.response.data.error_list) {
              for (let errorData of error.response.data.error_list) {
                // エラーメッセージをセット
                this.errors.push(errorData.error_msg)
              }
            }

            // エラーメッセージがある場合
            if (error.response.data.error_list !== null && error.response.data.error_list !== undefined) {
              // エラー要素の取得
              const errList = error.response.data.error_list
              // 各要素のエラーメッセージを出力する
              errList.forEach((objErr) => {
                let target = objErr.target
                let errorMsg = objErr.error_msg
                this.responseErrorMessage(target, errorMsg)
              })

              // エラーが出てる場所までスクロール
              this.scrollErrorPosition(this.error_scroll_position)
            }
          }
          // エラーレスポンスがない場合
          else {
            // エラーメッセージをセットする
            this.setErrors(error)
          }
        })
        // 処理が終了した場合
        .finally(() => {
          // ボタンのdisabledを解除する
          this.isSending = false
        })
    },
    /**
     * 見積書作成API用リクエストデータを初期化する
     */
    initializeQuotationRequestData() {
      // リクエストデータの初期化
      this.quotation_request_data = {
        // 契約番号
        contract_no: null,
        // 見積書種類
        quote_kind: {
          total:     false, // 総額見積書
          individual: false, // 個別見積書
        },
        // ユーザー数変更データ
        data: {
          light_user:    '', // ライト
          standard_user: '', // スタンダード
          premium_user:  '', // プレミアム
          chatplus_user: '', // チャットプラス
          // NEO情報
          neo: {
            neo_user:           '', // desknet's NEO
            app_suite_user:     '', // appsuite
            app_suite_user_old: '', // appsuite（価格改定前）
            web_conferencing:   '', // Web会議
            option: {
              // 交通費・経費
              expense_settlement: false,
              clouza: {}, // clouza
              sync: {
                user: '' // Sync for smartphones
              }
            },
            security: {
              secure: {}, // セキュアブラウザ（端末認証なし）
              client: {
                device: '' // クライアント認証
              }
            },
            mail: {
              arena: {
                account: '' // WebARENE
              },
              cyber: {
                account: '' // CYBERMAILΣ
              }
            },
            mail_security: {
              mailgates: {
                account: '' // MAILGATES Σ
              }
            }
          }
        },
        target_product: [],   // 対象製品
        opening_date:   null, // 開通希望日
        estimate_no:    '',   // お見積番号
        order_remarks:  ''    // 備考
      }
    },
    /**
     * 見積書作成API用リクエストデータを作成する
     */
    createQuotationRequestData() {
      // 見積書作成API用リクエストデータを初期化する
      this.initializeQuotationRequestData()
      // 契約番号
      this.quotation_request_data.contract_no = parseInt(this.contract_no)
      this.quotation_request_data.from_page = 'user-changes'
      // 見積書種類
      this.quotation_request_data.quote_kind.total      = this.quote_kind.total
      this.quotation_request_data.quote_kind.individual = this.quote_kind.individual
      // ライト ユーザー数
      if (this.light.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'light_user'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.light_user = this.light.value;
      }
      // スタンダード ユーザー数
      if (this.standard.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'standard_user'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.standard_user = this.standard.value;
      }
      // プレミアム ユーザー数
      if (this.premium.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'premium_user'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.premium_user = this.premium.value;
      }
      // チャットプラス ユーザー数
      if (this.chatplus.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'chatplus_user'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.chatplus_user = this.chatplus.value;
      }
      // desknet's NEO ユーザー数
      if (this.neo.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.neo_user'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.neo_user = this.neo.value;
      }
      // AppSuite（価格改定前） ユーザー数
      if (this.app_suite_old.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.app_suite_user_old'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.app_suite_user_old = this.app_suite_old.value;
      }
      // AppSuite ユーザー数
      if (this.app_suite.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.app_suite_user'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.app_suite_user = this.app_suite.value;
      }
      // Web会議室 会議室数
      if (this.web_conferencing.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.web_conferencing'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.web_conferencing = this.web_conferencing.value;
      }
      // 交通費・経費清算
      if (this[this.now_contract].value.length > 0 && this.expense_settlement.now_value.length > 0) {
        this.quotation_request_data.data.neo.option.expense_settlement = true;
      }
      // clouza ユーザー数
      if (this.clouza.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.option.clouza'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.option.clouza = this.clouza_info;
        this.quotation_request_data.data.neo.option.clouza.user = this.clouza.value;
      }
      // Sync for smartphones ユーザー数
      if (this.sync.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.option.sync'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.option.sync.user = this.sync.value;
      }
      // セキュアブラウザ（端末認証なし） ユーザー数
      if (this[this.now_contract].value.length > 0 && this.secure.now_value.length > 0) {
        this.quotation_request_data.data.neo.security.secure = this.secure_info;
        this.quotation_request_data.data.neo.security.secure.secure_browser_device = this[this.now_contract].value;
        this.quotation_request_data.data.neo.security.secure.now_secure_browser_device = this.secure.now_value
      }
      // クライアント認証 デバイス数
      if (this.client.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.security.client'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.security.client = this.client_info;
        // IPアドレスがnullの場合、空文字に変換
        if (this.quotation_request_data.data.neo.security.client.cert_except_ip === null) {
          this.quotation_request_data.data.neo.security.client.cert_except_ip = '';
        }
        this.quotation_request_data.data.neo.security.client.device = this.client.value;
      }
      // WEBARENA アカウント数
      if (this.arena.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.mail.arena'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.mail.arena = this.arena_info;
        this.quotation_request_data.data.neo.mail.arena.account = this.arena.value;
      }
      // CYBERMAILΣ アカウント数
      if (this.cyber.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.mail.cyber'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.mail.cyber = this.cyber_info;
        this.quotation_request_data.data.neo.mail.cyber.account = this.cyber.value;
      }
      // MAILGATES Σ アカウント数
      if (this.mailgates.value.length > 0) {
        // 対象製品オブジェクトのコピー
        const newTargetProduct = { ...this.target_product }
        newTargetProduct.name = 'neo.mail_security.mailgates'
        this.quotation_request_data.target_product.push(newTargetProduct)
        this.quotation_request_data.data.neo.mail.mailgates = this.mailgates_info;
        this.quotation_request_data.data.neo.mail_security.mailgates.account = this.mailgates.value;
      }
      // 共通部品
      // 開通希望日
      if (this.preferred_date.value !== null && this.preferred_date.value !== '') {
        this.quotation_request_data.opening_date = this.preferred_date.value
      }
      // 見積番号
      if (this.estimate.value !== null && this.estimate.value !== '') {
        this.quotation_request_data.estimate_no = this.estimate.value
      }
      // 備考
      if (this.remarks.value !== null && this.remarks.value !== '') {
        this.quotation_request_data.order_remarks = this.remarks.value
      }
    },
    // エラーメッセージ要素を空にする
    resetErrorMsg() {
      this.neo.error_msg               = [] // desknet's NEO
      this.light.error_msg             = [] // ライト
      this.standard.error_msg          = [] // スタンダード
      this.premium.error_msg           = [] // プレミアム
      this.chatplus.error_msg          = [] // チャットプラス
      this.app_suite_old.error_msg     = [] // Appsuite（価格改定前）
      this.app_suite.error_msg         = [] // Appsuite
      this.web_conferencing.error_msg  = [] // Web会議
      this.clouza.error_msg            = [] // clouza
      this.sync.error_msg              = [] // Sync for smartphones
      this.secure.error_msg            = [] // セキュアブラウザ（端末認証なし）
      this.client.error_msg            = [] // クライアント認証
      this.arena.error_msg             = [] // WebARENE
      this.cyber.error_msg             = [] // CYBERMAILΣ
      this.mailgates.error_msg         = [] // MAILGATES Σ
      this.increase_decrease.error_msg = [] // 増減値
      this.preferred_date.error_msg    = [] // 変更希望日
      this.remarks.error_msg           = [] // 備考
      this.quote_kind.error_msg        = [] // 見積種別
      this.estimate.error_msg          = [] // 見積もり番号
      this.error_msg_list              = [] // 画面上部のエラーメッセージ
    },
    // エラーメッセージを追加する
    responseErrorMessage(target, msg) {
      switch (target) {
        //------------------------------
        // 各項目のエラーメッセージ
        //------------------------------
        // desknet's Neo
        case 'neo_user':
          // エラーメッセージを追加する
          this.neo.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // プラン
        case 'plan_user':
          // 契約中の商品ごとにエラーメッセージを追加する
          switch (this.now_contract) {
            case 'light':
              this.light.error_msg.push(msg)
              break;
            case 'standard':
              this.standard.error_msg.push(msg)
              break;
            case 'premium':
              this.premium.error_msg.push(msg)
              break;
            case 'chatplus':
              this.chatplus.error_msg.push(msg)
              break;
          }

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // ライト
        case 'light_user':
          this.light.error_msg.push(msg)
          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break
        // スタンダード
        case 'standard_user':
          this.standard.error_msg.push(msg)
          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break
        // プレミアム
        case 'premium_user':
          this.premium.error_msg.push(msg)
          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break
        // チャットプラス
        case 'chatplus_user':
          this.chatplus.error_msg.push(msg)
          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // AppSuite（価格改定前）
        case 'app_suite_user_old':
          // エラーメッセージを追加する
          this.app_suite_old.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // AppSuite
        case 'app_suite_user':
          // エラーメッセージを追加する
          this.app_suite.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // desknet'sNEO Web会議室
        case 'web_conferencing':
          // エラーメッセージを追加する
          this.web_conferencing.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // タイムカード+CLOUZA
        case 'clouza_input':
          // エラーメッセージを追加する
          this.clouza.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // Sync for smartphone
        case 'option_sync_input':
          // エラーメッセージを追加する
          this.sync.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // セキュアブラウザ(端末認証なし)
        case 'secure_browser_terminal':
          // エラーメッセージを追加する
          this.secure.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // クライアント認証
        case 'client_auth_input':
          // エラーメッセージを追加する
          this.client.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // WEBARENA
        case 'web_arena_input':
          // エラーメッセージを追加する
          this.arena.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // CYBERMAILΣ
        case 'cyber_input':
          // エラーメッセージを追加する
          this.cyber.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break;

        // MAILGATES Σ
        case 'mailgates_input':
          // エラーメッセージを追加する
          this.mailgates.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break;

        //------------------------------
        // 組み合わせのエラーメッセージ
        //------------------------------
        // 「スタンダードプラン」 + 「AppSuite」
        case 'appsuite_standard':
          // エラーメッセージを追加する
          this.standard.error_msg.push(msg)
          this.app_suite.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // 「プレミアム」 + 「AppSuite」
        case 'appsuite_premium':
          // エラーメッセージを追加する
          this.premium.error_msg.push(msg)
          this.app_suite.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // セキュアブラウザ(端末認証なし) + タイムカード+CLOUZA
        case 'clouza_secure':
          // エラーメッセージを追加する
          this.clouza.error_msg.push(msg)
          this.secure.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // セキュアブラウザ(端末認証なし) + 接続元IPアドレス制限
        case 'permit_secure':
        case 'neo_permit_secure':
          // エラーメッセージを追加する
          this.secure.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        //「BASIC認証」の「除外IPあり」 ＋ 「セキュアブラウザ」の「端末認証なし」
        case 'basic_except_secure_terminal':
        case 'neo_basic_except_secure_terminal':
          // エラーメッセージを追加する
          this.secure.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // クライアント認証 + BASIC認証
        case 'basic_client':
        case 'neo_basic_client':
          // エラーメッセージを追加する
          this.client.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // クライアント認証 + セキュアブラウザ
        case 'client_secure':
          // エラーメッセージを追加する
          this.secure.error_msg.push(msg)
          this.client.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // クライアント認証 + 接続元IPアドレス制限
        case 'permit_client':
        case 'neo_permit_client':
          // エラーメッセージを追加する
          this.client.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // CYBERMAILΣ（オプションの組み合わせ）
        case 'cyber_leak_encode':
          // エラーメッセージを追加する
          this.cyber.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break;

        //「CYBERMAILΣ」＋「MAILGATES Σ」
        case 'cyber_mailgates':
          // エラーメッセージを追加する
          this.cyber.error_msg.push(msg)
          this.mailgates.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // 「MAILGATES Σ」の「誤送信対策・審査」 ＋ 「MAILGATES Σ」の「添付ファイル暗号化・分離」
        case 'prevent_missend_separation':
          // エラーメッセージを追加する
          this.mailgates.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break

        // 増減値
        case 'increase_decrease':
          // エラーメッセージを追加する
          this.increase_decrease.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 1;
          break;

        //------------------------------
        // 商品以外のエラーメッセージ
        //------------------------------
        // お見積番号
        case 'estimate':
          // エラーメッセージを追加する
          this.estimate.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = this.error_scroll_position > 2 ? 2 : this.error_scroll_position;
          break;

        // 変更希望日
        case 'opening_date':
          // エラーメッセージを追加する
          this.preferred_date.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = this.error_scroll_position > 3 ? 3 : this.error_scroll_position;
          break;

        // 備考
        case 'remarks':
          // エラーメッセージを追加する
          this.remarks.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = this.error_scroll_position > 4 ? 4 : this.error_scroll_position;
          break;

        // 見積書種類
        case 'quote_kind':
          // エラーメッセージを追加する
          this.quote_kind.error_msg.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = this.error_scroll_position > 5 ? 5 : this.error_scroll_position;
          break;

        // 変更お申込みができないユーザ
        case 'premise':
          // ご契約内容確認画面に遷移
          this.$router.push({
            name: "NeoServiceDetail",
            query: {"alert": "can_not_change"}
          })

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 99;
          break;

        default:
          // エラーメッセージを追加する
          this.error_msg_list.push(msg)

          // エラーメッセージを見せるための、スクロール位置を指定
          this.error_scroll_position = 99;
          break;
      }
    },
    /**
     * エラーの箇所までスクロールさせる
     */
    scrollErrorPosition() {
      // アンカー
      let anchor = "";

      // スクロール箇所毎にアンカーの値を設定
      switch (this.error_scroll_position) {
        // desknet's NEO
        case 1:
          anchor = "service";
          break;

        // 見積番号
        case 2:
          anchor = "estimate";
          break;

        // 変更希望日
        case 3:
          anchor = "preferred_date";
          break;

        // 備考
        case 4:
          anchor = "remarks";
          break;

        // 見積書種類
        case 5:
          anchor = 'quote_kind';
          break;
      }

      // アンカーが設定されている場合
      if (anchor !== "") {
        // アンカーの場所までスクロール
        document.getElementById(anchor).scrollIntoView();
      }
      // アンカーが設定されてない
      else {
        // 画面の一番上へ
        this.pageTopScroll();
      }
    },
  },
  watch: {
    /**
     * 個別見積書のチェックボックスが無効化された場合、チェックを外す
     */
    isDisabledIndividualQuotation(newVal) {
      // チェックボックスが無効化された場合
      if (newVal === true) {
        // チェックを外す
        this.quote_kind.individual = false;
      }
    },
  },
}
</script>

<style scoped>
.white-space {
  white-space: pre-line;
}
.neo-title-bg-color {
  background-color: #f2ffff;
}
.label-font-size {
  font-size: 16px;
}
.description-text-position {
  margin-top: -3px;
}
.datepicker-size {
  width: 210px !important;
}
.number-form-font-size {
  font-size: 18px;
}
.column-item-font-size {
  font-size: 20px;
}
.product-name-font-size {
  font-size: 16px;
}
.input-col-size {
  min-width: 260px !important;
}
.change-value-col-size {
  max-width: 200px;
}
.title-col-size {
  min-width: 350px;
}
.estimate-size {
  width: 400px !important;
}
.input-form-size {
  width: 92px !important;
}
.detail-button {
  height: 22px;
  font-size: 11px;
  display: inline;
  align-items: center;
  margin-bottom: 30px !important;
}
.error-message-space {
  margin-top: -7px !important;
}
.common-title-bg-color {
  background-color: #f5f5f5;
}
.plan-title-bg-color {
  background-color: #fceaee;
}
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.logo_appsuite {
  width:100px;
  height: auto;
}
.plan-border-color {
  border-color: #eb6ea0 !important;
}
.checkbox-description {
  font-size: 1rem;
}
.order-confirm-button {
  align-items: center;
  display: inline-flex;
  white-space: nowrap;
}
</style>
